module.exports = __webpack_public_path__ + "img/help11.b9d328f9.png";